import React from 'react';
import { IconProps } from '.';

const SvgBulbFillRounded = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M15 22a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-1h6v1ZM12 1a8 8 0 0 1 3.75 15.068V18.5a1 1 0 0 1-1 1h-5.5a1 1 0 0 1-1-1v-2.432A8 8 0 0 1 12 1Z'
      />
    </svg>
  );
};

export default SvgBulbFillRounded;
